import React from 'react';
import 'react-widgets/dist/css/react-widgets.css'
import { Loading } from 'components/common/index';
import { Redirect } from 'react-router-dom'
import {redirectTo} from "../../../components/v3/utilities/visitedpage.utils";

const CompanyAdminDashboard = () => {
  const userDetails = JSON.parse(localStorage.getItem('user'));
    if (userDetails && userDetails.loading) {
        return <Loading />
    }

    const url = userDetails?.lastVisitedPage?.url;
    return <Redirect to={redirectTo(url)} />
};

export { CompanyAdminDashboard };